import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ChangeCoverageScreenPreview } from './ChangeCoverageScreenPreview';
import FigoLoadingOverlay from '../../common/FigoLoadingOverlay';
import { PetCloudBreadcrumbs } from '../../myPets/common/PetCloudBreadcrumbs';

import { PolicyHeader } from '../PolicyHeader';
import { ORCA_CHANGE_COVERAGE_OPTIONS } from '../../navigation/routes.constants';
import { useChangeCoverageOrcaCa } from './hooks/useChangeCoverageOrcaCa';
import { useChangeCoverageOrcaEffect } from './hooks/useChangeCoverageOrcaEffect';

export const ChangeCoverageOrcaPreview = () => {
  const { t } = useTranslation('changeCoverage');
  const history = useHistory();

  const {
    coveragePeriodId,
    loading,
    marketingChanelId,
    policyNumber,
    powerUps,
    preview,
    queryPetId,
  } = useChangeCoverageOrcaCa();

  useChangeCoverageOrcaEffect();

  const onChangeCoverageClick = () => {
    const query = `petId=${queryPetId}`;

    const url = `${ORCA_CHANGE_COVERAGE_OPTIONS}?${query}`
      .replace(':marketingChanelId', marketingChanelId)
      .replace(':policyNumber', policyNumber)
      .replace(':coveragePeriodId', coveragePeriodId);

    history.push(url, { coveragePeriodId });
  };

  const onKeepClick = () => {
    history.goBack();
  };

  return (
    <div className="Change-coverage-insurance-screen-container">
      <PetCloudBreadcrumbs
        activeRoute={t('preview.renewalPreview')}
        rootRoute={t('insuranceTitle')}
      />

      <h1>{t('preview.renewalPreview')}</h1>

      <div className={`Colors-${marketingChanelId}`}>
        <PolicyHeader
          company={+marketingChanelId}
          logoClass="Change-coverage-header-logo"
        />
      </div>

      <ChangeCoverageScreenPreview
        hideCopayCard
        ignoreRate
        loading={loading}
        marketingChannel={marketingChanelId}
        onChangeCoverageClick={onChangeCoverageClick}
        onKeepClick={onKeepClick}
        policyNumber={policyNumber}
        powerUps={powerUps}
        preview={preview}
      />

      <FigoLoadingOverlay visible={loading} />
    </div>
  );
};
